
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Situacion } from '@/__env/lib/Pantalla/Situacion';
    import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import moment from 'moment';
    import { Wait, Random, WaitEntre } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: 'ok' | 'cargando' = 'cargando';

        @Prop( { type: Empresa } )
        public Empresa: Empresa;
        @Watch( 'Empresa', { immediate: true } )
        onEmpresa()
        {
            this.buscar();
        }

        public Item: Situacion = new Situacion();
        async buscar()
        {
            await WaitEntre( 1000, 1500 );
            this.Item = await Situacion.actual( this.Empresa.Id );
            this.Estado = 'ok';
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {


        }

        public Seleccionar( x: Empresa )
        {
            this.Controlador.EmpresaSeleccionado = x;
            this.Controlador.Vista.Modo = 'situacion-empresa';
        }
    }
